import { Button, Collapse, Stack, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { type FC, type PropsWithChildren, useEffect, useState } from "react";
import { type Control, useFormState } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	CarFormInput,
	CarFormOutput,
} from "web_myplann/Portfolio/Forms/CarForm/carFormSchema";

const PageResources = Resources.Portfolio.AddCar;

export type DisclosurePlacement = "top" | "bottom";

type Props = {
	control: Control<CarFormInput, unknown, CarFormOutput>;
	fields: readonly (keyof CarFormInput)[];
	disclosurePlacement: DisclosurePlacement;
};

export const CarExtendedParams: FC<PropsWithChildren<Props>> = ({
	control,
	fields,
	disclosurePlacement,
	children,
}) => {
	const { t } = useResource();
	const theme = useTheme();
	const [expanded, setExpanded] = useState(false);
	const { errors, submitCount } = useFormState({ control, name: fields });
	const hasError = fields.some((field) => errors[field]);

	useEffect(() => {
		if (hasError) {
			setExpanded(true);
		}
	}, [hasError, submitCount]);

	return (
		<>
			{disclosurePlacement === "bottom" && (
				<Collapse in={expanded} timeout="auto" unmountOnExit>
					<Stack>{children}</Stack>
				</Collapse>
			)}
			<Button
				variant="disclosure"
				aria-expanded={expanded}
				onClick={() => setExpanded((prev) => !prev)}
				endIcon={
					expanded ? (
						<ChevronUp size={theme.iconSize.sm} />
					) : (
						<ChevronDown size={theme.iconSize.sm} />
					)
				}
			>
				{t(
					expanded
						? PageResources.hideParameters
						: PageResources.showParameters,
				)}
			</Button>
			{disclosurePlacement === "top" && (
				<Collapse in={expanded} timeout="auto" unmountOnExit>
					<Stack>{children}</Stack>
				</Collapse>
			)}
		</>
	);
};
